module.exports = __webpack_public_path__ + "static/ogimage-3cbd38f0603605b5d8cc0856273e3226.png";